import React from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import { sqlDateToLabel } from 'helpers/helpers';
import useGeneralStyles from 'apps/Pdf/styles/general';
import { ContractLegalData } from 'stores/workflowStores/workflowPersonalDataStore/model';

interface Props {
  data: ContractLegalData;
}

const CompanyData = (props: Props) => {
  const styles = useGeneralStyles();
  const { t } = useTranslation();
  const { data } = props;

  return (
    <div className={`${styles.twoColumns} ${styles.lines}`}>
      <Grid container>
        <Grid item xs={4}>
          Název:
        </Grid>
        <Grid item xs={8} className={`${styles.bold} ${styles.value}`}>
          {data.companyName}
        </Grid>
        <Grid item xs={4}>
          Sídlo:
        </Grid>
        <Grid item xs={8} className={styles.value}>
          {data.permanentAddressCompact}, {t(`country_${data.permanentAddress.country}`)}
        </Grid>
        <Grid item xs={4}>
          IČO:
        </Grid>
        <Grid item xs={8} className={styles.value}>
          {data.companyNumber}
        </Grid>
        {data.legalEntityIdentifier && (
          <>
            <Grid item xs={4}>
              LEI:
            </Grid>
            <Grid item xs={8} className={styles.value}>
              {data.legalEntityIdentifier}
            </Grid>
          </>
        )}
        <Grid item xs={4}>
          Datum vzniku spol.:
        </Grid>
        <Grid item xs={8} className={styles.value}>
          {sqlDateToLabel(data.registrationDate, 'dd. MM. yyyy')}
        </Grid>
        <Grid item xs={4}>
          Místo vzniku spol.:
        </Grid>
        <Grid item xs={8} className={styles.value}>
          {data.registrationPlace}, {t(`country_${data.registrationCountry}`)}
        </Grid>
        <Grid item xs={4}>
          Oblast ekonomické činnosti:
        </Grid>
        <Grid item xs={8} className={styles.value}>
          {t(`nace_${data.naceCode}`)}
        </Grid>
      </Grid>
      <Grid container>
        {'taxResidency' in data && (
          <>
            <Grid item xs={4}>
              Stát daňové rezidence:
            </Grid>
            <Grid item xs={8} className={styles.value}>
              {t(`country_${data.taxResidency.country}`)}
            </Grid>
            {data.taxResidency.taxNumber && (
              <>
                <Grid item xs={4}>
                  DIČ:
                </Grid>
                <Grid item xs={8} className={styles.value}>
                  {data.taxResidency.taxNumber.number}
                </Grid>
              </>
            )}
          </>
        )}
        <Grid item xs={4}>
          Korespondenční adresa:
        </Grid>
        <Grid item xs={8} className={styles.value}>
          {data.contactAddressCompact ? (
            <>
              {data.contactAddressCompact}, {t(`country_${data.contactAddress.country}`)}
            </>
          ) : (
            t('contract_contactAddress_same_legal')
          )}
        </Grid>
        <Grid item xs={4}>
          E-mail:
        </Grid>
        <Grid item xs={8} className={styles.value}>
          {data.email}
        </Grid>
        <Grid item xs={4}>
          Telefon:
        </Grid>
        <Grid item xs={8} className={styles.value}>
          {data.phone}
        </Grid>
      </Grid>
    </div>
  );
};

export default CompanyData;
